import { initVueApp } from '../lib/utils/vue3compat/init_vue_app.js?vue3';
import initSourceCodeDropdowns from '../vue_shared/components/download_dropdown/init_download_dropdowns.js?vue3';
import SortDropdown from './components/sort_dropdown.vue?vue3';

const mountDropdownApp = (el) => {
  const { filterTagsPath } = el.dataset;

  return initVueApp({
    el,
    name: 'SortTagsDropdownApp',
    provide: {
      filterTagsPath,
    },
    component: SortDropdown,
  });
};

initSourceCodeDropdowns();

export default () => {
  const el = document.getElementById('js-tags-sort-dropdown');
  return el ? mountDropdownApp(el) : null;
};
